import {useQuery} from '@tanstack/react-query'
import {getGoalForFollower} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useFetchGoalForFollowerV3 = (goalId?: string | null) => {
    return useQuery({
        queryKey: [QUERY_KEYS.selectedGoal, goalId],
        queryFn: () => getGoalForFollower({goalId: goalId!}),
        enabled: !!goalId
    })
}
